export default __webpack_public_path__ + "static/media/1.ae251ceb.png";